import actionTypes from 'registration/actions/action-types';
import utils from 'utils/lsp-utils-service';
import * as api from 'registration/resources/registration.api';

export const validateOwnerDataRequest = () => ({
  type: actionTypes.VALIDATE_OWNER_DATA_REQUEST,
});

export const validateOwnerDataSuccess = (ownerData) => ({
  type: actionTypes.VALIDATE_OWNER_DATA_SUCCESS,
  ownerData,
});

export const validateOwnerDataFailure = () => ({
  type: actionTypes.VALIDATE_OWNER_DATA_FAILURE,
});

export const validateOwnerData = (form) => async (dispatch, getState) => {
  try {
    const { registration } = getState();
    const { retailerId, salts } = registration.retailer;
    const { passcode, tellerId = null, emailAddress = null, firstName, lastName } = form;

    dispatch(validateOwnerDataRequest());

    const params = {
      retailerId,
      tellerId,
      firstName,
      lastName,
      email: emailAddress,
      hashedPins: passcode ? utils.getHashes(passcode, salts) : null,
    };

    const ownerData = await api.validateOwnerData(params);

    dispatch(validateOwnerDataSuccess(ownerData));
  } catch (error) {
    console.error('VALIDATE_OWNER_DATA_FAILURE', error);
    dispatch(validateOwnerDataFailure());
  }
};



// WEBPACK FOOTER //
// ./src/modules/registration/actions/validate-owner-data.actions.js